import { render, staticRenderFns } from "./group-competency-report.vue?vue&type=template&id=62c79914"
import script from "./group-competency-report.ts?vue&type=script&lang=ts&external"
export * from "./group-competency-report.ts?vue&type=script&lang=ts&external"
import style0 from "./group-competency-report.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports